import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTable, useSortBy } from 'react-table';
import { Button, Table, Card, Modal } from 'react-bootstrap';
import { Download, DownloadCloud } from 'react-feather';
import filter from './filter.svg';
import Bolt from './lightning-bolt.svg';
import standardStar from './standard-star.svg';
import AscSort from '../asc-sort.svg';
import DescSort from '../desc-sort.svg';
import { downloadActiveLetter, downloadAllLetters } from '../../../redux/slices/DisputeCenterSlice';
import { useDispatch, useSelector } from 'react-redux';
import { fetchNotification, setNotifcationBedge } from '../../../redux/slices/CommonSlice';
import StandardModal from '../StandardModal';
import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import $ from "jquery"
import { blankCurrentStatus } from '../../../redux/slices/DashboardSlice';

const CustomCardModal = ({ title, content, buttons, show, onHide }) => {
  return (
    <Modal show={show} onHide={onHide} centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{content}</p>
        {Object.entries(buttons).map(([key, value]) => (
          <Button
            key={key}
            variant={value.btnClass.replace('btn-', '')}
            className='me-2'
            onClick={() => {
              value.action();
              onHide();
            }}>
            {value.text}
          </Button>
        ))}
      </Modal.Body>
    </Modal>
  );
};


const ActiveLetter = props => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { dispute_letter_left_list, dispute_letter_current_plan_id, documentPopUp, setIsDocUpload, setDocumentPopUp, setShowDocumentsModal, documentUploadCallback, currentRound, currentStatus} = props;
  var currentPlan = dispute_letter_current_plan_id == 2 ? 'Enhanced' : `Standard`;
  const getAllReportData = useSelector(state => state.reports.getAllReportData);
  const uploadDocumentStatus = useSelector(state => state.uploadDocument.status);
  const userCurrentInfo = useSelector(state => state.uploadDocument.uploadDocumentData);

  const clientName = useRef(getAllReportData?.data?.client_name)
  const skipDocuments = useRef(userCurrentInfo?.response?.skip_documents)
  const mailingOption = useRef(userCurrentInfo?.response?.mailing_option)
  const clientDocuments = useRef([userCurrentInfo?.response?.social_security, userCurrentInfo?.response?.proof_of_address,userCurrentInfo?.response?.drivers_license])

  const [showCardModal, setShowCardModal] = useState(false);
  const [modalButtons, setModalButtons] = useState({});
  const [leterVerbiage, setLeterVerbiage] = useState("To Generate Your Dispute Letters and get them mailed. Upload your documents.");


  const handleDownloadClick = (data, url) => {
    let obj = {
      letter_id: data.original.id,
      client_id: data.original.client_id,
    };

    if (data.original.downloaded === 0) {
      setShowModal(true);
      setDownloadModalData(obj);
    } else {
      dispatch(downloadActiveLetter(obj));
      dispatch(fetchNotification());
      dispatch(setNotifcationBedge(true));
      window.open(url, '_blank');
    }
  };

  const handleDownloadChoice = choice => {
    setShowModal(false);
    if (choice === 'Yes') {
      dispatch(downloadActiveLetter(downloadModalData));
      dispatch(fetchNotification());
      dispatch(setNotifcationBedge(true));
    }
  };

  const modifiedDisputeLetterList = dispute_letter_left_list.map(item => {
    return {
      ...item,
      planType: currentPlan,
    };
  });

  const [showModal, setShowModal] = useState(false);
  const [downloadModalData, setDownloadModalData] = useState(null);

  const basePath = document.body.dataset['app_base_url'];


  const handleDownloadAllClick = (rows, name) => {
    const filePaths = rows.filter(row => row.is_active).map(item => basePath + item.letter_name);
    dispatch(downloadAllLetters({ filePaths, name }));
    setTimeout(() => {
      dispatch(
        downloadActiveLetter({
          letter_id: 'all',
          client_id: rows[0] && rows[0].client_id,
        })
      );
      dispatch(blankCurrentStatus())
    }, 2000);
    
  };


  const columns = React.useMemo(() => {
    const baseColumns = [
      {
        Header: <span className='fourteenth-step'>Date</span>,
        id: 1,
        accessor: 'created_at',
        Cell: ({ value }) => {
          let dateVal = moment(value).format('MMMM, Do YYYY').replace('<sup>', '-').replace('</sup>', '-').split('-');

          return (
            <>
              {dateVal[0]}
              <sup>{dateVal[1]}</sup>
              {dateVal[2]}
            </>
          );
        },
      },
      {
        Header: <span className='fifteenth-step'>Destination</span>,
        id: 2,
        accessor: 'letter_print_type',
      },
      {
        Header: <span className='sixteenth-step'>Tactic Style</span>,
        id: 'tacticStyle',
        Cell: ({ row }) => {
          const planType = row.original.planType;

          return (
            <div className='d-flex justify-content-center'>
              <div stroke='none' style={{ width: '28px', height: '28px' }} className='align-content-cnnter p-1 bg-primary rounded-circle bg-opacity-50 d-flex shadow'>
                {planType === 'Standard' ? <img src={standardStar} alt='standard star' fill='var(--bs-primary)' className='text-primary m-auto' width='17' height='17' stroke='0' /> : <img src={Bolt} alt='premium stars' fill='var(--bs-primary)' className='text-primary m-auto' width='17' height='17' stroke='0' />}
              </div>
              <div className='ms-3 lh-1 my-auto text-dark-blue text-regular-16'>
                {' '}
                {planType} {planType === 'Standard' && row.original.disputely_mail == '1' && 'with Mailing'}{' '}
              </div>
            </div>
          );
        },
      },

      {
        Header: <span className='seventeenth-step'>Status</span>,
        id: 4,
        accessor: () => 'is_active',
        Cell: ({ row }) => (
          <div className='d-flex justify-content-center align-items-center'>
            <div>
              <span style={{ fontSize: '0px', fontWeight: '300' }} className={`d-inline-flex ${row.original.is_active ? "bg-success" : ""} p-1 rounded-circle mx-auto me-2`}></span>
            </div>
            <div className='text-dark-blue text-regular-16'>{row.original.is_active ? "Active" : "Completed"}</div>
          </div>
        ),
      },
      {
        Header: <span className='eighteenth-step'>Items Disputed</span>,
        id: 5,
        accessor: 'item_count',
      },
    ];
    if (currentPlan !== "Enhanced") {
      baseColumns.push({
        Header: obj => obj.data.length > 0 ? (
          <a id='download-all' href={void 0} onClick={() => handleDownloadAllClick(obj.data, clientName.current)} className='text-decoration-none'>
            Download All <DownloadCloud width={20} height={20} strokeWidth={2} color='rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1))' />
          </a>
        ): <></>,
        accessor: 'letter_name',
        Cell: ({ value, row }) => (
          <a href={void 0} onClick={() => handleDownloadClick(row, basePath + value)} className='text-decoration-none'>
            <Download width={20} height={20} strokeWidth={2} color={row.original.downloaded == '1' ? 'grey' : 'rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1))'} />
          </a>
        ),
        disableSortBy: true,
      });
    }

    return baseColumns;
  }, [currentPlan]);
  const data = React.useMemo(() => modifiedDisputeLetterList, [dispute_letter_left_list]);

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({ columns, data }, useSortBy);




useEffect(() => {
  const buttons = {};

  function getButtons(status=false){
    // if (mailingOption.current === '1' && currentPlan !== 'Enhanced')
      buttons.generate = {
        text: 'Generate Anyways',
        btnClass: 'btn-outline-danger',
        action: () => $.confirm({
          title: "Generate Letters Anyways!",
          content: "Are you sure you want to generate the letters without uploading all documents?",
          buttons: {
            yes: {
              text: "Yes",
              btnClass: "btn-outline-danger",
              action: () => documentUploadCallback(true)
            },
            no: {
              text: "Upload All Documents",
              btnClass: "btn-outline-primary",
              action: () => setShowCardModal(true)
            }
          }
        }),
      };

      buttons.later = {
        text: 'Upload Later',
        btnClass: 'btn-outline-info',
        action: () => {},
      };

      buttons.upload = {
        text: 'Upload Documents',
        btnClass: 'btn-success',
        action: () => { 
          if(status) setIsDocUpload(true);
          setShowDocumentsModal(true);
        },
      };
  }
  if (uploadDocumentStatus === "succeeded" && skipDocuments.current === '1' && !documentPopUp && !dispute_letter_left_list.length && currentRound) {
    setDocumentPopUp(true);
    
    if(clientDocuments.current.includes('')){
      setLeterVerbiage('To Generate Your Dispute Letters and get them mailed. Upload your documents.')
      getButtons()
    }else{
      setLeterVerbiage("All Documents Uploaded, Generate Your Dispute Letters")
      buttons.generate = {
        text: 'Generate Letters',
        btnClass: 'btn-success',
        action: documentUploadCallback,
      };
    }
    // Remove the $.confirm block
    setModalButtons(buttons);
    setShowCardModal(true);
  }else if(uploadDocumentStatus === "succeeded" && !documentPopUp && clientDocuments.current.includes('') && !dispute_letter_left_list.filter(row => row.is_active).length && currentRound >= 2 && currentStatus !== 7){
    setDocumentPopUp(true);
    setLeterVerbiage("Before you start your next Dispute Cycle, we recommend you upload your Identification Documents. Doing so will help you avoid issues with the creditors/credit bureaus verifying your identity and/or delays with the processing of your dispute letters")
    getButtons(true)

    setModalButtons(buttons);
    setShowCardModal(true);
  }
}, [documentPopUp, skipDocuments, uploadDocumentStatus, dispute_letter_left_list, currentRound]);

// console.log(skipDocuments)
  return (
    <>
      <Table borderless responsive id='activeLetter' {...getTableProps()} style={{ tableLayout: 'auto', position: 'relative', whiteSpace: 'nowrap' }}>
        <style>
          {`
        td {
          padding: 1rem !important;
        }
        #activeLetter > thead th:nth-child(2) {
          width:440px !important;
        }
        #activeLetter > thead th:nth-child(5) {
          width:150px !important;
        }
        #activeLetter > thead th:nth-child(6) {
          width:150px !important;
        }
        `}
        </style>
        <thead className='rounded-3 thirteenth-step' style={{ backgroundColor: '#F8F9FD' }}>
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <th
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  style={{
                    cursor: 'pointer',
                  }}>
                  {column.render('Header')}
                  {column.isSorted ? <img src={column.isSortedDesc ? DescSort : AscSort} alt={column.isSortedDesc ? 'Descending' : 'Ascending'} style={{ width: '15px', height: '15px', marginLeft: '.5rem' }} /> : ''}
                </th>
              ))}
            </tr>
          ))}
        </thead>

        <tbody {...getTableBodyProps()}>
          {skipDocuments.current === '0' || rows.length > 0 ? (
            rows.map(row => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map(cell => {
                    return (
                      <td {...cell.getCellProps()} className='text-dark-blue text-regular-16'>
                        {cell.render('Cell')}
                      </td>
                    );
                  })}
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={6} className='text-center'>
                <h1 className='mt-5'>Letters Not Generated Yet!</h1>
                <p className='h3'>{leterVerbiage}</p>
                {
                  clientDocuments.current.map(doc => !['', null, undefined].includes(doc)).includes(false)  ?
                  <>
                    <Button size='lg' className='px-5 py-3 my-4' onClick={() => setShowDocumentsModal(true)}>
                      Upload Documents
                    </Button>
                  </>
                  : 
                  <>
                    <Button size='lg' className='px-5 py-3 my-4' onClick={() => documentUploadCallback()}>
                      Generate Letters
                    </Button>
                  </>
                }
                
              </td>
            </tr>
          )}
        </tbody>
      </Table>
      {showModal && <StandardModal handleChoice={handleDownloadChoice} />}
      {showCardModal && <CustomCardModal title='Letters Not Generated Yet!' content={leterVerbiage} buttons={modalButtons} show={showCardModal} onHide={() => setShowCardModal(false)} />}
    </>
  );
};

export default ActiveLetter;
